import { useMergeRefs } from '@floating-ui/react';
import classnames from 'classnames';
import * as React from 'react';
import { ScrollParentProvider } from './scroll_context.js';
import '../box/index.js';
import '../visually_hidden/index.js';
import { container } from './scroll_parent.css.js';
import { Box } from '../box/box.js';
import { VisuallyHidden } from '../visually_hidden/visually_hidden.js';

const defaultElement = 'section';
/**
 * Container that populates the context with a ref that can be accessed via `useScrollParent()` hook.
 * This is useful in cases where you want to pass down the scrollable element through the render tree,
 * for example when you want to modify the scroll position of the container from some interaction inside.
 */
const ScrollParent = React.forwardRef(function ScrollParent({ as: Element = defaultElement, children, className, label, labelledBy, ...rest }, externalRef) {
    const [internalRef, setInternalRef] = React.useState(null);
    const ref = useMergeRefs([externalRef, setInternalRef]);
    return (React.createElement(Box, { tabIndex: 0, "aria-labelledby": typeof labelledBy === 'string' ? labelledBy : undefined, className: classnames(container, className), ...rest, as: Element, ref: ref },
        label !== undefined && React.createElement(VisuallyHidden, null, label),
        React.createElement(ScrollParentProvider, { value: internalRef }, children)));
});

export { ScrollParent };
